import _ from 'lodash';
import React from 'react';
import { RUN_TYPES } from 'v2/common/constants/index';
import { runPropTypes } from 'common/propTypes';
import classNames from 'classnames';
import MoneyDisplay from 'common/components/MoneyDisplay';
import withErrorBoundary from './withErrorBoundary/index';
import OrderTypeBadge from './OrderTypeBadge';

const propTypes = {
  run: runPropTypes.isRequired
};
const defaultProps = {};

const RunListOrderType = ({ run }) => {
  const {
    run_type: runType,
    order_type: orderType,
    summary
  } = run;

  const profit = _.get(summary, 'profit', 0);
  const isBacktest = runType === RUN_TYPES.historic;

  const moneyStyle = classNames('mt-1', {
    'text-success': profit > 0,
    'text-danger ': profit <= 0,
  });

  const renderRunListOrderType = (
    <div>
      {<OrderTypeBadge orderType={orderType} isBacktest={isBacktest} />}
      {isBacktest && (
        <div className={moneyStyle}>
          <MoneyDisplay shouldColor>{profit}</MoneyDisplay>
        </div>
      )}
    </div>
  );

  return renderRunListOrderType;
};

export default withErrorBoundary(RunListOrderType, 'Errored', false);

RunListOrderType.propTypes = propTypes;
RunListOrderType.defaultProps = defaultProps;
